module.exports = __webpack_public_path__ + "img/licence3.b9805f7f.jpg";